// extracted by mini-css-extract-plugin
export default {"container":"pages_container__3bt-s","contentWrapper":"pages_contentWrapper__12B+z"};